import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { QuestionView } from '@views';
import { useNavigationEligibility } from '@components/SurveyDrawer/NavigationEligibilityContextProvider';

interface DropdownResponseProps {
  currentQuestion: QuestionView;
}

export const DropdownResponse: FC<DropdownResponseProps> = ({ currentQuestion }) => {
  const { triggerEligibility } = useNavigationEligibility();

  // Initialize selected state from currentQuestion
  const initialSelectedId = currentQuestion.responses.find((r) => r.selected)?.id ?? -1;
  const [selected, setSelected] = useState<number>(initialSelectedId);

  useEffect(() => {
    // Update local state if question changes (e.g. user navigates next/previous)
    const newSelected = currentQuestion.responses.find((r) => r.selected)?.id ?? -1;
    setSelected(newSelected);
  }, [currentQuestion]);

  const setQuestionResponse = (optIdx: number, value: string) => {
    currentQuestion.responses.forEach((x, i) => {
      x.selected = i === optIdx;
      x.textResponse = i === optIdx ? value : '';
    });
  };

  const handleDropdownChange = (e: SelectChangeEvent<number>) => {
    const selectedId = Number(e.target.value);
    const optIdx = currentQuestion.responses.findIndex((x) => x.id === selectedId);

    if (optIdx !== -1) {
      setQuestionResponse(optIdx, String(selectedId));
      setSelected(selectedId);
      triggerEligibility();
    }
  };

  const dropdownResponses = currentQuestion.responses.filter((opt) => opt.responseType === 'Dropdown');

  if (dropdownResponses.length === 0) return null;

  return (
    <FormControl fullWidth sx={{ padding: 0 }}>
      <Select value={selected} onChange={handleDropdownChange} displayEmpty>
        <MenuItem value={-1} disabled>
          Select an option
        </MenuItem>
        {dropdownResponses.map((opt) => (
          <MenuItem key={`option-${opt.id}`} value={opt.id}>
            {opt.text}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
